/* Both manuals are in the document. Selection changes visibility, never the page. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.p1InstallReady) return;
    root.dataset.p1InstallReady = 'true';
    const chooser = root.querySelector('[data-p1-chooser]');
    const panels = Array.from(root.querySelectorAll('[data-p1-panel]'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function restore(options) {
      options = options || {};
      const hash = window.location.hash.slice(1);
      const panel = panels.find(function (item) {
        const route = item.dataset.p1Panel;
        return hash === route || hash.indexOf(route + '-') === 0;
      });
      chooser.hidden = Boolean(panel);
      panels.forEach(function (item) { item.hidden = item !== panel; });
      const selection = panel ? panel.dataset.p1Panel : 'keuze';
      const reset = selection !== root.dataset.p1Selection;
      root.dataset.p1Selection = selection;
      if (panel) {
        const guide = panel.querySelector('[data-p1-guide]');
        const steps = Array.from(guide.querySelectorAll('[data-p1-step]'));
        const index = steps.findIndex(function (step) { return step.id === hash; });
        guide.dispatchEvent(new CustomEvent('p1:activate', { detail: { index: Math.max(0, index), focusStep: index >= 0, reset: reset } }));
        const anchor = document.getElementById(hash);
        if (index < 0 && anchor && panel.contains(anchor)) {
          window.requestAnimationFrame(function () { anchor.scrollIntoView({ block: 'start' }); });
        } else if (index < 0 && options.focus) {
          const title = guide.querySelector('.zv-app-handleiding__title');
          title.setAttribute('tabindex', '-1');
          title.focus({ preventScroll: true });
          window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        }
      } else if (options.focus) {
        chooser.querySelector('[data-p1-choice]').focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
    }
    function choose(route) {
      const url = new URL(window.location.href);
      url.hash = route;
      if (url.href !== window.location.href) window.history.pushState(null, '', url);
      restore({ focus: true });
    }
    root.addEventListener('click', function (event) {
      const choice = event.target.closest('[data-p1-choice]');
      if (choice && root.contains(choice)) choose(choice.dataset.p1Choice);
      const change = event.target.closest('[data-p1-change]');
      if (change && root.contains(change)) choose('keuze');
    });
    window.addEventListener('popstate', function () { restore({ focus: true }); });
    window.addEventListener('hashchange', function () { restore({ focus: true }); });
    root.addEventListener('shopify:block:select', function (event) {
      const panel = event.target.closest('[data-p1-panel]');
      if (!panel) return;
      const step = event.target.closest('[data-p1-step]');
      choose(step ? step.id : panel.dataset.p1Panel);
    });
    restore();
  }
  function initAll(context) {
    if (context.matches && context.matches('[data-p1-install]')) init(context);
    context.querySelectorAll('[data-p1-install]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
